import AddIcons from '@/icons/AddIcons'
import CheckIcons from '@/icons/CheckIcons'
import { DOCUMENT_TYPES } from '@/modules/Employee/constants'
import { renderFileItem } from '@/utils/function'
import React from 'react'
import { useFieldArray, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, GridHookForm } from 'vnetwork-ui'

interface ProfileTabProps {
    formControl: UseFormReturn<any>
    onNext?: () => void
    onPrevious?: () => void
    isPending: boolean
}

const ProfileTab: React.FC<ProfileTabProps> = ({
    formControl,
    onNext,
    onPrevious,
    isPending,
}) => {
    const { t } = useTranslation()
    const { fields, append, remove } = useFieldArray({
        control: formControl.control,
        name: 'documents',
    })
    return (
        <>
            <div className="flex items-center justify-end mb-2">
                <Button
                    size="small"
                    variant="outlined"
                    type="button"
                    startIcon={<AddIcons />}
                    onClick={() => {
                        append({ document_type: '', file: null })
                    }}
                >
                    {t('employees.add_document')}
                </Button>
            </div>
            {fields.map((field, index) => (
                <GridHookForm
                    key={field.id}
                    actions={
                        index === fields.length - 1
                            ? [
                                  {
                                      type: 'button',
                                      variant: 'outlined',
                                      disabled: isPending,
                                      title: t('employees.previous_step'),
                                      handler: () => {
                                          onPrevious?.()
                                      },
                                  },
                                  {
                                      type: 'button',
                                      startIcon: <CheckIcons />,
                                      variant: 'contained',
                                      disabled: isPending,
                                      loading: isPending,
                                      title: t('employees.completed'),
                                      handler: () => {
                                          onNext?.()
                                      },
                                  },
                              ]
                            : []
                    }
                    subForm={true}
                    className="grid grid-cols-1 md:grid-cols-4 gap-4 border-b border-b-blue-500 pb-4"
                    formControl={formControl}
                    data={[
                        {
                            formItemProps: {
                                type: 'select',
                                allowClear: false,
                                name: `documents.${index}.document_type`,
                                label: t('employees.document_type'),
                                options: DOCUMENT_TYPES(t),
                            },
                            className: 'md:col-span-1',
                        },
                        {
                            formItemProps: {
                                type: 'files',
                                name: `documents.${index}.attachments`,
                                label: t('employees.file'),
                                multiple: true,
                                renderFileItem: (file: File) => (
                                    <div className="grid grid-cols-1 gap-2">
                                        <div className="col-span-1">
                                            {renderFileItem(file, () =>
                                                remove(index)
                                            )}
                                        </div>
                                    </div>
                                ),
                            },
                            className: 'md:col-span-3',
                        },
                    ]}
                />
            ))}
        </>
    )
}

export default ProfileTab
